<template>
<!-- eslint-disable max-len -->
<narrative-player :narratives="narratives" :on-complete="onComplete"></narrative-player>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';

import NarrativePlayer from '../narrative/NarrativePlayer';

export default {
  components: {
    NarrativePlayer
  },
  computed: {
    ...mapGetters([
      'avatars',
      'game'
    ]),
    narratives() {
      return this.game && this.game.introNarratives || [];
    }
  },
  methods: {
    ...mapActions([
      'setGameIntroViewed',
      'selectAvatar'
    ]),
    async onComplete() {
      await this.setGameIntroViewed();
      if (this.avatars.length < 2) {
        try {
          const { character: avatar } = this.avatars[0] || {};
          await this.selectAvatar({ avatar });
        } catch (err) {
          if (await this.$router.handleGameError(err)) return;
          this.$router.showGameErrorCritical();
        }
      }
      this.$router.nextGameState();
    }
  }
};
</script>

<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/components/game/pages/GameIntro.vue